import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = ["for"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "h-5 w-5 animate-spin rounded-full border-2 border-ink/30 border-t-ink"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)

import axios from "axios";
import { reactive, ref } from "vue";

type FieldId = "topic" | "from" | "message";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactForm',
  setup(__props) {

const fields: {
  id: FieldId;
  label: string;
  type?: string;
  textarea?: boolean;
}[] = [
  { id: "topic", label: "Asunto", type: "text" },
  { id: "from", label: "Email", type: "email" },
  { id: "message", label: "Cuéntanos sobre tu pieza", textarea: true },
];

const status = ref<"idle" | "loading" | "sent" | "error">("idle");
const formData = reactive<Record<FieldId, string>>({
  topic: "",
  from: "",
  message: "",
});

const submitForm = async () => {
  try {
    status.value = "loading";
    await axios.post(
      "https://5e9a57oic6.execute-api.us-east-2.amazonaws.com/default/sendEmail",
      {
        name: formData.topic,
        message: formData.message,
        email: formData.from,
      },
      { headers: { "Content-Type": "application/json" } }
    );
    formData.topic = "";
    formData.from = "";
    formData.message = "";
    status.value = "sent";
  } catch (error) {
    console.log(error);
    status.value = "error";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "space-y-6",
    onSubmit: _withModifiers(submitForm, ["prevent"])
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fields, (field) => {
      return _createElementVNode("div", {
        key: field.id,
        class: "group relative"
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(field.textarea ? 'textarea' : 'input'), {
          id: field.id,
          modelValue: formData[field.id],
          "onUpdate:modelValue": ($event: any) => ((formData[field.id]) = $event),
          type: field.type,
          name: field.id,
          rows: field.textarea ? 5 : undefined,
          placeholder: " ",
          required: "",
          class: "peer w-full resize-none rounded-xl border border-copper/20 bg-ink/60 px-5 pb-3 pt-7 text-ivory outline-none transition-all duration-300 focus:border-copper focus:bg-ink focus:shadow-[0_0_0_4px_rgba(213,155,106,0.12)]"
        }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "type", "name", "rows"])),
        _createElementVNode("label", {
          for: field.id,
          class: "pointer-events-none absolute left-5 top-2 text-[11px] uppercase tracking-[0.2em] text-copper transition-all duration-200 peer-placeholder-shown:top-5 peer-placeholder-shown:text-sm peer-placeholder-shown:normal-case peer-placeholder-shown:tracking-normal peer-placeholder-shown:text-ivory/40 peer-focus:top-2 peer-focus:text-[11px] peer-focus:uppercase peer-focus:tracking-[0.2em] peer-focus:text-copper"
        }, _toDisplayString(field.label), 9, _hoisted_2)
      ])
    }), 64)),
    _createElementVNode("button", {
      type: "submit",
      class: "btn-molten w-full",
      disabled: status.value === 'loading'
    }, [
      (status.value === 'loading')
        ? (_openBlock(), _createElementBlock("span", _hoisted_4))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" Enviar mensaje "),
            _hoisted_5
          ], 64))
    ], 8, _hoisted_3),
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-300",
      "enter-from-class": "opacity-0 translate-y-2",
      "leave-active-class": "transition duration-200",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (status.value === 'sent' || status.value === 'error')
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["rounded-xl border px-5 py-4 text-sm", 
          status.value === 'sent'
            ? 'border-copper/40 bg-copper/10 text-copper-light'
            : 'border-red-400/40 bg-red-500/10 text-red-300'
        ]),
              role: "status"
            }, _toDisplayString(status.value === "sent"
            ? "¡Gracias! Recibimos tu mensaje y te contactaremos pronto."
            : "No pudimos enviar tu mensaje. Inténtalo de nuevo o escríbenos por correo."), 3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 40, _hoisted_1))
}
}

})